/**
 * A "global" sync source is a collection with no per-item lifecycle of its
 * own (unlike comments, which only sync while a particular itemId is on
 * screen) - it should just sync in full, on a fixed schedule, for as long
 * as the user is authenticated. New collections that want this behavior
 * register themselves here (see `registerSyncSources.ts`) rather than the
 * polling engine in `GlobalSyncMiddleware.ts` needing to know about them.
 */
export interface GlobalSyncSource {
  key: string;
  intervalMs: number;
  sync: () => Promise<void>;
  // sources are run in ascending priority tiers on cold start (ties run in
  // parallel within a tier); a later tier only starts once every source in
  // the tier(s) before it has finished its initial sync. Omit for the
  // default tier (0) - only set this when a source's pull genuinely depends
  // on another source's data already being local (see registerSyncSources.ts).
  priority?: number;
}

const sources = new Map<string, GlobalSyncSource>();

export const registerGlobalSync = (source: GlobalSyncSource): void => {
  sources.set(source.key, source);
};

export const getGlobalSyncSources = (): GlobalSyncSource[] => Array.from(sources.values());
